<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
<div>
  {{$t('news.template.candidate.valNew.p1')}}
  {{news.textParams[0]}}
  {{$t('news.template.candidate.valNew.p2')}}
  {{news.textParams[1]}} {{news.textParams[2]}}.
</div>
</template>
